export class WorkflowApplicationDocument {
  id: string;
  workflowApplicationId: string;
  workflowApplicationActivityDataId?: string;
  workflowApplicationDataEntityId?: string;
  templateCode?: string;
  createdOn: string;
  createdOnString: string;
  createdBy: string;
  modifiedOn: string;
  modifiedOnString: string;
  modifiedBy: string;
  deletedOn?: string;
  deletedOnString?: string;
  deletedBy?: string;
  uploadedOn?: string;
  uploadedOnString?: string;
  uploadedBy?: string;
  documentName: string;
  documentPath: string;
  reviewRequired?: boolean;
  isRequired: boolean; // Computed: true if workflowApplicationActivityDataId has a value, false otherwise
  reviewedBy?: string;
  reviewedOn?: string;
  reviewedOnString?: string;
  clientId: string;
  editing?: boolean;
isReviewed?:string
  constructor(options?: Partial<WorkflowApplicationDocument>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}
